/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface DashboardControllerGetMainDashboardResponse {
  code: number;
  data: {
    lastStatsUpdatedAt: string | null;
    kpi: {
      totalCustomerCount: number;
      cumulativeAutomationAppliedCount: number;
      cumulativeChatConsultationCount: number;
    };
    customerManagement: {
      monthlyCustomerInput: number;
      newPatientDbCount: number;
      dailyGraph: {
        date: string;
        customerInput: number;
        newPatientDb: number;
      }[];
    };
    consultationManagement: {
      automationMessageSentCount: number;
      newAutomationAppliedCount: number;
      monthlyConsultationCount: number;
    };
    revisitMarketingManagement: {
      campaignCount: number;
      messageSentCount: number;
      receiveSuccessCount: number;
      receiveSuccessRate: number;
      customerReadCount: number;
      conversionRate: number;
    };
    treatmentManagement: {
      rankings: {
        rank: number;
        treatmentCategoryID: string;
        name: string;
        color: string;
        inputCount: number;
        rankDelta: number;
      }[];
      insight: {
        mostNotInputTag: {
          treatmentCategoryID: string;
          name: string;
          color: string;
          notInputCustomerCount: number;
        } | null;
        mostCombinationUpsellTag: {
          treatmentCategoryID: string;
          name: string;
          color: string;
          recommendedPartner: {
            treatmentCategoryID: string;
            name: string;
            color: string;
          };
          withoutCombinationCustomerCount: number;
        } | null;
      };
    };
    chatManagement: {
      channels: {
        channelType: string;
        consultationCount: number;
        newInflowCount: number;
      }[];
      response: {
        unansweredOver6hCount: number;
        avgResponseWaitTime: number;
      };
    };
  };
  message: string;
}

export interface DashboardControllerGetTreatmentTagsResponse {
  code: number;
  data: {
    rankings: {
      rank: number;
      treatmentCategoryID: string;
      name: string;
      color: string;
      inputCount: number;
      rankDelta: number;
      popularCombination: {
        partner: {
          treatmentCategoryID: string;
          name: string;
          color: string;
        };
        count: number;
      } | null;
    }[];
  };
  message: string;
}

export interface DashboardControllerGetChatConsultationsResponse {
  code: number;
  data: {
    accounts: {
      channelAccountID: string;
      channelType: string;
      accountName: string;
      dailyStats: {
        date: string;
        customerChatCount: number;
        consultationCount: number;
        newInflowCount: number;
        unansweredCount: number;
        avgResponseTime: number;
      }[];
    }[];
  };
  message: string;
}

export interface DashboardControllerBackfillStatsResponse {
  code: number;
  data: {
    startDate: string;
    endDate: string;
    hospitalID?: string;
    skipExisting?: boolean;
  };
  message: string;
}

export type DashboardControllerGetMainDashboardData = DashboardControllerGetMainDashboardResponse;

export type DashboardControllerGetTreatmentTagsData = DashboardControllerGetTreatmentTagsResponse;

export type DashboardControllerGetChatConsultationsData = DashboardControllerGetChatConsultationsResponse;

export type DashboardControllerBackfillStatsData = DashboardControllerBackfillStatsResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 상담현황 대시보드 메인 조회
     *
     * @tags V3-Dashboard
     * @name DashboardControllerGetMainDashboard
     * @summary 상단 누적 KPI 3 + 관리 현황 5종(고객/상담/재진마케팅/시술/채팅) (month=YYYY-MM)
     * @request GET:/v3/api/dashboard
     * @secure
     * @response `200` `DashboardControllerGetMainDashboardData` success
     */
    dashboardControllerGetMainDashboard: (params: RequestParams = {}) =>
      this.request<DashboardControllerGetMainDashboardData, any>({
        path: `/v3/api/dashboard`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 상세(인기 시·수술) 조회
     *
     * @tags V3-Dashboard
     * @name DashboardControllerGetTreatmentTags
     * @summary 전체 순위 + 입력 건수 + 인기 조합 (month=YYYY-MM)
     * @request GET:/v3/api/dashboard/treatment-tags
     * @secure
     * @response `200` `DashboardControllerGetTreatmentTagsData` success
     */
    dashboardControllerGetTreatmentTags: (params: RequestParams = {}) =>
      this.request<DashboardControllerGetTreatmentTagsData, any>({
        path: `/v3/api/dashboard/treatment-tags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅 상담 상세 조회
     *
     * @tags V3-Dashboard
     * @name DashboardControllerGetChatConsultations
     * @summary 채널 계정 × 일별 (고객 채팅 / 신규 유입 / 응대 현황) (month=YYYY-MM)
     * @request GET:/v3/api/dashboard/chat-consultations
     * @secure
     * @response `200` `DashboardControllerGetChatConsultationsData` success
     */
    dashboardControllerGetChatConsultations: (params: RequestParams = {}) =>
      this.request<DashboardControllerGetChatConsultationsData, any>({
        path: `/v3/api/dashboard/chat-consultations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 대시보드 daily stats 백필/재실행(관리자)
     *
     * @tags V3-Dashboard
     * @name DashboardControllerBackfillStats
     * @summary startDate~endDate 일자 범위를 재집계한다 (6/12 이원화 백필용)
     * @request POST:/v3/api/dashboard/stats/backfill
     * @secure
     * @response `200` `DashboardControllerBackfillStatsData` success
     */
    dashboardControllerBackfillStats: (params: RequestParams = {}) =>
      this.request<DashboardControllerBackfillStatsData, any>({
        path: `/v3/api/dashboard/stats/backfill`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
